import "./HeadTermInput.css";

const HeadTermInput = (props) => {
  const { handleInputChange, headTerm } = props;

  return (
    <section id="sku-input-container" className="head-term-input-section">
      <div className="head-term-input-inputs-inner">
        <label htmlFor="skuOrAsinInput">SEED & SEARCH TERM</label>
        <input
          id="headTerm"
          value={headTerm}
          name="headTerm"
          onChange={handleInputChange}
        />
      </div>
    </section>
  );
};

export default HeadTermInput;
